<template>
  <div class="edit-avatar">
    <app-form-picture
      :url="url"
      :timeout="timeout"
      @add="onAdd"
      @progress="onProgress"
      @error="onError"
      @input="onSuccess"
      @sending="onSending"
    >
      <app-circle-progress :progress="progress" :variant="progressVariant">
        <app-avatar :url="lazyAvatarUrl" :name="fullName" size="lg" />
      </app-circle-progress>

      <app-disc size="lg">E</app-disc>
    </app-form-picture>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import AppAvatar from "@/components/user/Avatar";
import AppDisc from "@/components/ui/Disc";
import AppCircleProgress from "@/components/ui/CircleProgress";
import AppFormPicture from "@/components/form/FormPicture";
import { config } from "@/constants";

export default {
  name: "AppEditAvatar",
  props: {
    customer: {
      type: Object,
      required: true,
      default: null,
    },
  },
  components: {
    AppFormPicture,
    AppCircleProgress,
    AppDisc,
    AppAvatar,
  },
  watch: {
    avatarUrl: {
      handler(value) {
        this.lazyAvatarUrl = value;
      },
      immediate: true,
    },
  },
  computed: {
    avatarUrl() {
      return this.customer.avatarUrl;
    },
    fullName() {
      return this.customer.fullName;
    },
    url() {
      return `${config.apiBaseURL}/customers/${this.customer.id}/avatar`;
    },
  },
  methods: {
    ...mapActions("customers", ["setCustomer"]),
    onAdd(file, url) {
      const image = new Image();
      image.src = url;
      image.addEventListener("load", () => {
        this.lazyAvatarUrl = url;
      });
    },
    onProgress(file, { percent }) {
      this.progressVariant = "success";
      this.progress = percent;
    },
    onSuccess(customer) {
      this.setCustomer(customer);

      setTimeout(() => {
        this.progressVariant = "light";
        this.progress = 0;
      }, 1000);
    },
    onSending() {
      this.progress = 0;
      this.progressVariant = "light";
    },
    onError(file, message) {
      this.progress = 100;
      this.progressVariant = "danger";
      alert(message);
    },
  },
  data() {
    return {
      lazyAvatarUrl: this.avatarUrl,
      progress: 0,
      progressVariant: "success",
      timeout: Number(config.apiTimeout),
    };
  },
};
</script>

<style lang="scss" scoped>
.edit-avatar {
  display: inline-block;
  position: relative;
  width: 7.5rem;
  height: 7.5rem;

  .disc {
    position: absolute;
    bottom: 0.5rem;
    right: 0.5rem;
  }
}
</style>
